function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { getSubmitButtonOptions } from ".././../utils";
export default function SubmitButton(_ref) {
  var uiSchema = _ref.uiSchema;

  var _getSubmitButtonOptio = getSubmitButtonOptions(uiSchema),
      submitText = _getSubmitButtonOptio.submitText,
      norender = _getSubmitButtonOptio.norender,
      submitButtonProps = _getSubmitButtonOptio.props;

  return /*#__PURE__*/React.createElement("div", null, !norender && /*#__PURE__*/React.createElement("button", _extends({
    type: "submit"
  }, submitButtonProps, {
    className: "btn btn-info"
  }), submitText));
}